// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__Ost+r","skeletonFade":"Skeleton_skeletonFade__7czpG"};